import Api from "@/services/Api";

export default {
  getCityData(params, callback, errCallback) {
    const authUser = JSON.parse(window.localStorage.getItem("userljrs"));

    params.fields = "id,name";
    params.order = "name ASC";

    return Api()
      .get("/LJRSS3Production/_table/mcity", {
        params: params,
        headers: {
          "x-dreamfactory-session-token": authUser.session_token
        }
      })
      .then(data => {
        callback(data);
      })
      .catch(error => {
        errCallback(error);
      });
  }
};
